import immer from "immer";

const Reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return immer(state, (draft) => {
        draft.loading = true;
      });
    case "LOGIN_SUCCESS":
      return immer(state, (draft) => {
        draft.loading = false;
        draft.user = action.payload;
      });
    case "LOGOUT":
      return immer(state, (draft) => {
        draft.user = null;
      });
    case "LOGIN_FAILURE":
      return immer(state, (draft) => {
        draft.loading = false;
      });
    default:
      return state;
  }
};

export default Reducer;
